<template>
    <template v-if="bcFolderStore.listChildren[$id] || bcFolderStore.loading">
      <folder-grid :list="bcFolderStore.listChildren[$id]" :loading="bcFolderStore.loading" v-if="bcFolderStore.view === 'grid'" :show-new="showNew" />
      <folder-table :list="bcFolderStore.listChildren[$id]" :loading="bcFolderStore.loading" v-if="bcFolderStore.view === 'table'" class="folder__Wrapper"/>
    </template>
    <slot name="empty" v-if="!bcFolderStore.loading && (!bcFolderStore.listChildren[$id] || bcFolderStore.listChildren[$id].length === 0)">
    </slot>
</template>
<script>
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { trackPageView } from '../gtm'

export default {
  props: ['id', 'rootId', 'lang'],
  data () {
    return {
      $id: this.id ? parseInt(this.id) : 0,
      $rootId: this.rootId ? parseInt(this.rootId) : 0
    }
  },
  computed: {
    ...mapStores(useBcFolderStore, useBcSelectedStore),
    showNew() {
      return this.$route.matched[0].name !== 'BCTrash'
        && this.$route.matched[0].name !== 'BCSharedFolder'
        && this.bcFolderStore.current?.can_edit
    }
  },
  mounted() {
    this.$watch(vm => [vm.id, vm.rootId], () => {
      this.$id = parseInt(this.id)
      this.$rootId = parseInt(this.rootId)
      this.bcFolderStore.show = this.$route.matched[0].name === 'BCSharedFolder' ? 'shared' : 'bc'

      //if (this.$rootId)
      this.bcFolderStore.loadFolder(null).then(() => {
        this.bcFolderStore.loadFolder(this.$rootId ? this.$rootId : (this.$id || null)).then(() => {
          if (this.$id) {
            this.bcFolderStore?.enter(this.$id)
          }

          this.bcSelectedStore?.reset(
            () => new Map((this.bcFolderStore.listChildren[this.$id] || []).map(item => [item.url, item])),
            'url',
            null,
            this.bcFolderStore.hashTable[this.$id]
          )

          this.$nextTick(() => {
            trackPageView()
          })
        })
      })
    }, {
      immediate: true, // run immediately
    })
  },
}
</script>
